import * as IconFa5 from "react-icons/fa";
import * as IconFa6 from "react-icons/fa6";
import { BsLink45Deg } from "react-icons/bs";

const IconByLink = ({ isGlobal, idIcon, name, color = undefined, ...rest }) => {
    const styles = {
        iconLink: {
            color: color
        }
    }

    if ((idIcon == null && name == null) || isGlobal) {
        return <BsLink45Deg style={styles.iconLink} {...rest} />;
    }

    const IconComponent = IconFa5[name] ?? IconFa6[name];

    if (!IconComponent) {
        return <BsLink45Deg style={styles.iconLink} {...rest} />;
    }

    return <IconComponent style={styles.iconLink} {...rest} />;
};

const DynamicIcon = ({ isGlobal, idIcon, name, color = undefined, ...rest }) => {
    return (
        <IconByLink isGlobal={isGlobal} idIcon={idIcon} name={name} color={color} {...rest}/>
    )
};

export default DynamicIcon;